<body>
    
  <div class="container">
 <div class= "about">
    
    <h1 class="title-text">About Me</h1>
       
    </div>
    <div class="row mt-20px">
    
    <!--<div class="col">-->
      <div class="col">
    <div id="demo" class="carousel slide" data-ride="carousel">
    
        <!-- Indicators -->
        <ul class="carousel-indicators">
          <li data-target="#demo" data-slide-to="0" class="active"></li>
          <li data-target="#demo" data-slide-to="1"></li>
          <li data-target="#demo" data-slide-to="2"></li>
          <li data-target="#demo" data-slide-to="3"></li>
          <li data-target="#demo" data-slide-to="4"></li>
           <li data-target="#demo" data-slide-to="5"></li>
          <li data-target="#demo" data-slide-to="6"></li>
          <li data-target="#demo" data-slide-to="7"></li>
          <li data-target="#demo" data-slide-to="8"></li>
          <li data-target="#demo" data-slide-to="9"></li>
          <li data-target="#demo" data-slide-to="10"></li>
          <li data-target="#demo" data-slide-to="11"></li>
          <li data-target="#demo" data-slide-to="12"></li>
         
         

        </ul>
        
        <!-- The slideshow -->
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="assets/images/id21.jpg" alt="Los Angeles" width="1100" height="500">
          </div>
          <div class="carousel-item">
            <img src="assets/images/certificate.jpg" alt="Chicago" width="1100" height="500">
          </div>

         
          <div class="carousel-item">
            <img src="assets/images/id2.jpg" alt="Chicago" width="1100" height="500">
          </div>
          <div class="carousel-item">
            <img src="assets/images/id4.jpg" alt="New York" width="1100" height="500">
          </div>
          <div class="carousel-item">
            <img src="assets/images/id22.jpg" alt="Chicago" width="1100" height="500">
          </div>
          <div class="carousel-item">
            <img src="assets/images/id3.jpg" alt="New York" width="1100" height="500">
          </div>
           <div class="carousel-item">
            <img src="assets/images/id7.jpg" alt="Chicago" width="1100" height="500">
          </div>
          <div class="carousel-item">
            <img src="assets/images/id8.jpg" alt="New York" width="1100" height="500">
          </div>
          <div class="carousel-item">
            <img src="assets/images/id9.jpg" alt="Chicago" width="1100" height="500">
          </div>
          <div class="carousel-item">
            <img src="assets/images/id10.jpg" alt="New York" width="1100" height="500">
          </div>
           <div class="carousel-item">
            <img src="assets/images/id11.jpg" alt="Chicago" width="1100" height="500">
          </div>
          <div class="carousel-item">
            <img src="assets/images/id12.jpg" alt="New York" width="1100" height="500">
          </div>
        </div>
        
        <!-- Left and right controls -->
        <a class="carousel-control-prev" href="#demo" data-slide="prev">
          <span class="carousel-control-prev-icon"></span>
        </a>
        <a class="carousel-control-next" href="#demo" data-slide="next">
          <span class="carousel-control-next-icon"></span>
        </a>
      </div>
    </div>
    <!--<div class="col-md-3">-->
      <div class="col-md">

     
      <p>
        Hello,  I am Ms. Nirmalie and I have a bachelor’s degree in Science.
        I have taught algebra, geometry, trigonometry ,
        pre calculus, chemistry and physics for more than 15 years at International Christian Acadamy
        in Rome Italy.<br><br>
        I have started teaching <span class="purple-text">ICT</span> and <span class="purple-text">Computer Science</span> in Italian state schools where I used Visual Basic 
        to explain programming concepts. Furthermore, I teach web development in ICT classes where I familiarize students with <span class="purple-text">HTML</span> and <span class="purple-text">CSS</span>.
        I have discovered a passion for coding and have dedicated my time to create web sites including my own. 
        I use <span class="purple-text">Angular</span> for my own projects and incorporate elements of <span>Angular Material</span> and <span>Bootstrap</span>.<br>  
                      
        Contact Me: wnirmalie@yahoo.com
        </p>
        
        
    </div>
    
      </div>
</div>
<div class="footer"></div>
    </body> 
